export default __webpack_public_path__ + "static/media/american-football.bdd3f746.svg";